import {useEffect, useState} from "react";

export const useValidatorInputPanelAdm = (search?: string) => {

    const [errorMessageSearch, setErrorMessageSearch] = useState('');
    const [isValidDataForm, setIsValidDataForm] = useState<boolean>(false);


    useEffect(() => {
        validate();
    }, [search]);

    const validate = (): boolean => {
        setErrorMessageSearch('');
        if (!search) {
            setErrorMessageSearch('Insira um código de referência ou CNPJ');
            setIsValidDataForm(false);
            return false;
        } else {
            setIsValidDataForm(true);
            return true;
        }
    }

    return {
        errorMessageSearch,
        validate,
        isValidDataForm
    }
};
